// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1tTLO","rotate":"Spinner_rotate__1NLbq","dash":"Spinner_dash__aKcoo","color":"Spinner_color__3u6ge"};